/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @param {string} [overrideInstallationName] - Optional installation name to use instead of global config
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = (text, overrideInstallationName) => {
    if (!text) return text;

    const installationName =
      overrideInstallationName ?? globalConfig.value?.installationName;
    if (!installationName) return text;

    return text.replace(/Chatwoot/g, installationName);
  };

  return {
    replaceInstallationName,
  };
}
